import { css } from '@emotion/react';

export const card = css`
  background-color: white;
  box-shadow: var(--elevation-medium);
  border-radius: 8px;
`;

export const growOnHover = css`
  transition: all 0.3s ease-in-out;

  &:hover {
    transform: scale(1.15);
  }
`;
